import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'default' | 'large';
  showTagline?: boolean;
  variant?: 'default' | 'light';
}

const sizeStyles = {
  small: { fontSize: 20, iconSize: 40 },
  default: { fontSize: 32, iconSize: 64 }, // Even smaller for header
  large: { fontSize: 40, iconSize: 72 }, // Even smaller for header
};

export const Logo: React.FC<LogoProps> = ({ 
  size = 'default', 
  showTagline = false,
  variant = 'default' 
}) => {
  const sizeConfig = sizeStyles[size];
  const [imageError, setImageError] = React.useState(false);
  
  // Calculate container dimensions to fit header - much more compact
  const containerWidth = size === 'large' ? 160 : sizeConfig.iconSize * 1.3; // Even smaller multipliers
  const containerHeight = size === 'large' ? 50 : sizeConfig.iconSize * 0.6; // Even smaller height
  
  return (
    <div className={`logo-container logo-${size} logo-${variant}`} data-testid="logo-container">
      <div className="logo-content">
        <div className="logo-icon-container" style={{ width: containerWidth, height: containerHeight }}>
          {!imageError ? (
            <img
              src="/Quickko-LogoGDCaptionV2.svg"
              alt="Quickko Logo"
              className="logo-image"
              style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'left center' }}
              onLoad={() => {
                console.log('Quickko logo SVG loaded successfully');
              }}
              onError={(error) => {
                console.warn('Quickko logo SVG failed to load, trying fallback:', error);
                setImageError(true);
              }}
            />
          ) : (
            <span className="logo-fallback" style={{ fontSize: sizeConfig.iconSize * 0.6 }}>
              👍
            </span>
          )}
        </div>
      </div>
      
      {/* Tagline is included in the SVG logo, so we don't show it separately when SVG is loaded */}
      {showTagline && imageError && (
        <span className="logo-tagline">
          One stop for every need
        </span>
      )}
    </div>
  );
};

export default Logo;

